exports = module.exports = require("../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".re-form.showing-confirmation[data-v-69ebfdbc] {\n  position: relative;\n}\n.re-form.showing-confirmation .re-form-confirmation[data-v-69ebfdbc] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  background-color: rgb(255, 255, 255);\n}", ""]);

// exports
